import { render } from "./games_grid.vue?vue&type=template&id=149a2956"
import script from "./games_grid.vue?vue&type=script&lang=js"
export * from "./games_grid.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__